/**
 * Renders sanitised rich text HTML content. Used to display notes and other
 * rich text fields that were authored with the RichTextEditor.
 *
 * Handles both legacy plain text (no HTML tags) and rich text HTML.
 */

import { sanitiseRichTextHtml } from '@snootsvet/shared'

import { cn } from '@/frontend/lib/utils'

export interface RichTextContentProps {
  html: string
  className?: string
}

export function RichTextContent({ html, className }: RichTextContentProps) {
  const content = sanitiseRichTextHtml(html).replace(/<p>\s*<br\s*\/?>\s*<\/p>/g, '<p></p>')

  return (
    <div
      className={cn(
        'text-sm',
        '[&_b]:font-bold [&_strong]:font-bold [&_i]:italic [&_em]:italic',
        '[&_ul]:list-disc [&_ul]:ml-4 [&_ol]:list-decimal [&_ol]:ml-4',
        '[&_a]:text-primary [&_a]:underline [&_a]:break-all',
        '[&_p+p]:mt-1 [&_li+li]:mt-0.5 [&_p:empty]:min-h-[1lh] [&>p:empty:last-child]:hidden',
        '[&_p:empty]:mt-0 [&_p:empty+p]:mt-0',
        '[&>p+ul]:mt-1 [&>p+ol]:mt-1 [&>ul+p:not(:empty)]:mt-3 [&>ol+p:not(:empty)]:mt-3',
        className
      )}
      dangerouslySetInnerHTML={{ __html: content }}
    />
  )
}
